import { utils } from "src/utils";
import { useAuthStore } from "src/store/auth";

const publicPages = ["/", "index", "error", "admin/actions"]; //public pages which do not need authentation
// Páginas personales: cualquier usuario con sesión, sin permiso de rol (el
// backend ya filtra lo que cada quien ve).
const sessionPages = ["pendientes/index"];

const roleAbilities = {
  admin: [],
  user: [],
  costos: [],
  administrativo: [],
  "project management": [],
};

export function useAuth() {
  const store = useAuthStore();

  const user = store.state.user;
  const userRoles = Array.isArray(store.state.userRole)
    ? store.state.userRole
    : (store.state.userRole ? [store.state.userRole] : []);
  const normalizedRoles = userRoles.map((role) => String(role).toLowerCase());
  const userRole = userRoles.join(', ');

  let isLoggedIn = false;
  let userName = "";
  let userEmail = "";
  let userId = "";
  let userPhoto = "";
  let userPhone = "";

  setUserData();

  function setUserData() {
    if (user) {
      isLoggedIn = true;
      userName = user.name;
      userId = user.id;
      userEmail = user.email;
      userPhoto = user.img;
      userPhone = user.phone;
    }
  }

  async function getUserData() {
    const token = store.getLoginToken();
    //Token is available, user might still be logged in
    if (token) {
      try {
        //fetch user data for the first time and saves in the store
        await store.getUserData();
      } catch (e) {
        store.logout(); //token must have expired
      }
    }
    return {
      user: store.state.user,
      userRole: store.state.userRole,
      userPages: store.state.userPages,
    };
  }

  function login(payload) {
    return store.login(payload);
  }

  function saveLoginData(loginData, rememberUser) {
    const payload = { loginData, rememberUser };
    store.saveLoginData(payload);
  }

  function logout() {
    store.logout();
  }

  const pageRequiredAuth = function (path) {
    const { pageName, routePath } = utils.parseRoutePath(path);
    return !publicPages.includes(pageName) && !publicPages.includes(routePath);
  };

  const canView = function (path) {
    if (path) {
      let { routePath } = utils.parseRoutePath(path);
      const userPages = store.state.userPages;
      return publicPages.includes(routePath)
        || (isLoggedIn && sessionPages.includes(routePath))
        || userPages.includes(routePath);
    }
    return true;
  };

  // Chequeo directo de un permiso "recurso/accion" (ej. "employees/add"),
  // para mostrar/ocultar botones y acciones dentro de una misma página --
  // distinto de canView(), que es para gatear rutas completas.
  const hasPermission = function (permission) {
    return store.state.userPages.includes(permission);
  };

  const canManage = function (page, userRecId) {
    if (normalizedRoles.some((role) => (roleAbilities[role] || []).includes(page))) {
      return true;
    }
    return userRecId == userId;
  };

  function isOwner(userRecId) {
    if (user) {
      return userRecId == userId;
    }
    return false;
  }

  const isAdmin = normalizedRoles.includes("admin");

  const isUser = normalizedRoles.includes("user");

  const isCostos = normalizedRoles.includes("costos");

  const isAdministrativo = normalizedRoles.includes("administrativo");

  const isProjectManagement = normalizedRoles.includes("project management");

  const isCoordinador = normalizedRoles.includes("coordinador");

  const isRH = normalizedRoles.includes("recursos humanos") || normalizedRoles.includes("rh");

  return {
    store,
    isLoggedIn,
    user,
    userName,
    userId,
    userEmail,
    userPhone,
    userPhoto,
    userRole,
    userRoles,
    getUserData,
    login,
    logout,
    saveLoginData,
    pageRequiredAuth,
    canView,
    canManage,
    hasPermission,
    isOwner,
    isAdmin,
    isUser,
    isCostos,
    isAdministrativo,
    isProjectManagement,
    isCoordinador,
    isRH,
  };
}
